import * as React from "react";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

interface IProps {}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  title: {
    color: palette.common.white,
    fontSize: 30,
    fontWeight: 300,
    marginTop: 30,
    textTransform: "uppercase"
  }
});

@(withStyles(styles) as any)
export default class JobsSectionTitle extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { classes } = this.props;
    return (
      <Typography className={classes!.title}>{this.props.children}</Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobsSectionTitle.tsx